var React = require('react');
var MainCSS = require('mainCSS');
var { Link, useLocation, useNavigate } = require('react-router-dom');
var { connect } = require('react-redux');
var authenticateActions = require('authenticateActions');
var userActions = require('@actions/userActions');
var FarmingUnitsDropdown = require('FarmingUnitsDropdown');
var DistributionsDropdown = require('DistributionsDropdown');
var {
  DashboardBannerForMobile,
  DashboardBannerForDesktop,
} = require('Banners');
const { withTranslation } = require('react-i18next');
var farmingUnitManager = require('farmingUnitManager');
const { plannerType } = require('@managers/planningManager');
var helpers = require('helpers');
var rolesManager = require('@managers/rolesManager');
var NotificationsCenterHeaderContainer = require('./NotificationsCenter/NotificationsCenterHeaderContainer');
var AllFarmTabCoachmark = require('./AllFarmTabCoachmark.jsx');
const { getItem, setItem } = require('localStorageManager');
const { VIEW_MODE_STORAGE_KEY, VIEW_MODE } = require('./viewModeStorage');

// Centers the 24x24 preferences icon inside the round notificationsBtn button
// (identical interactive treatment to the notification bell button).
const preferencesButtonStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
};

const Header = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const allFarmTabRef = React.useRef(null);
  const [shouldShowAllFarmCoachmark, setShouldShowAllFarmCoachmark] =
    React.useState(false);

  var dismissAllFarmCoachmark = function () {
    setShouldShowAllFarmCoachmark(false);
    props.setAllFarmTabCoachmarkSeen();
  };

  const { t } = props;
  const pathname = location.pathname;
  const monitoring_active = pathname === '/';
  const planning_active = pathname.startsWith('/Planning');
  const insights_active = pathname.startsWith('/Insights');
  const irrigation_monitoring_active = pathname.startsWith('/AllFarmView');
  const inMainScreen =
    monitoring_active ||
    planning_active ||
    insights_active ||
    irrigation_monitoring_active;

  // Farm View is now open to ALL users — the 'all_farm' remote-config gate was
  // removed, so the Farm View tab is always available.
  const hasAllFarmAccess = true;

  // Redirect to saved view mode on initial load
  const hasRedirected = React.useRef(false);
  React.useEffect(() => {
    if (hasRedirected.current || location.pathname !== '/') return;
    try {
      const savedViewMode = getItem(VIEW_MODE_STORAGE_KEY, null);
      if (savedViewMode === VIEW_MODE.FARM && hasAllFarmAccess) {
        hasRedirected.current = true;
        navigate('/AllFarmView#');
      }
    } catch (error) {
      console.error('Failed to read view mode from localStorage:', error);
    }
  }, [location.pathname, hasAllFarmAccess, navigate]);

  // Save view mode when navigating between tabs
  const handleTabClick = React.useCallback((tabKey) => {
    if (tabKey === 'farm_view') {
      setItem(VIEW_MODE_STORAGE_KEY, VIEW_MODE.FARM);
    } else if (tabKey === 'monitoring') {
      setItem(VIEW_MODE_STORAGE_KEY, VIEW_MODE.FIELD);
    }
  }, []);

  if (props.shouldDisplayNavigation == false) {
    return <div></div>;
  }

  const onLogoutButtonClick = () => {
    props.logout();
  };

  const inMainDashboard = monitoring_active;

  // Check if any field has by_weeks mode. A skeleton farming unit (not yet
  // hydrated with a full distribution tree) has no `fields` key — guard with
  // `?.` so Object.values doesn't throw on undefined.
  const hasByWeeksState =
    props.selectedFarmingUnit &&
    Object.values(props.selectedFarmingUnit.fields || {}).some(
      (field) =>
        field.settings &&
        field.settings.planner_settings &&
        field.settings.planner_settings.type ===
          plannerType.WEEKLY_RECOMMENDATION,
    );

  // Only show planner if no field has by_weeks mode
  var shouldDisplayPlanner =
    !hasByWeeksState &&
    farmingUnitManager.shouldDisplayPlanner(props.selectedFarmingUnit);
  let isAdmin = rolesManager.getIsAdmin(
    props.allDistributions,
    props.user_details && props.user_details.is_root,
  );
  let isCropExpert = rolesManager.isCropExpert(
    props.user_details && props.user_details.is_root,
    props.user_details && props.user_details.email,
  );
  let hasInsightsAccess = rolesManager.isNdripUser(
    props.user_details && props.user_details.email,
  );

  // Only show monitoring if no field has by_weeks mode
  const shouldDisplayMonitoring =
    !hasByWeeksState || hasInsightsAccess || hasAllFarmAccess;

  let hasNotificationsCenterAccess = helpers.getNotificationsCenterAccess(
    props.user_details && props.user_details.email,
  );
  let isAbleToSeeDistributionDropdown =
    rolesManager.isAbleToSeeDistributionDropdown(
      props.allDistributions,
      props.user_details && props.user_details.is_root,
    );
  let isAbleToSeeFarmingUnitDropdown =
    rolesManager.isAbleToSeeFarmingUnitDropdown(
      props.allDistributions,
      props.user_details && props.user_details.is_root,
    );

  // Tab configuration array
  const tabs = [
    {
      key: 'monitoring',
      label: t('field_view').toUpperCase(),
      to: '/',
      active: monitoring_active,
      show: shouldDisplayMonitoring,
      width: '100%',
    },
    {
      key: 'farm_view',
      label: t('farm_view').toUpperCase(),
      to: '/AllFarmView#',
      active: irrigation_monitoring_active,
      show: hasAllFarmAccess,
      width: '100%',
    },
    {
      key: 'planning',
      label: t('planning').toUpperCase(),
      to: '/Planning#',
      active: planning_active,
      show: shouldDisplayPlanner,
      width: '77px',
    },
    {
      key: 'insights',
      label: t('insights_tab').toUpperCase(),
      to: '/Insights#',
      active: insights_active,
      show: hasInsightsAccess,
      width: '71px',
    },
  ];
  const visibleTabs = tabs.filter((tab) => tab.show);

  return (
    <div
      className='container-fluid position-fixed'
      style={{ zIndex: 1000, top: 0 }}
    >
      <div
        className='row bg-white align-items-center text-md-left text-center d-flex justify-content-between'
        style={{ height: props.headerHeight.toString() + 'px' }}
      >
        <div
          className='text-left align-items-center d-flex'
          style={{ width: '30%' }}
        >
          <Link to='/'>
            <img
              src={require('images/general/ndrip-logo.png?lastmod=12345678')}
              className='logo-image-height ml-0 ml-md-3 mb-0 mt-0'
              alt='N-Drip Logo'
            />
          </Link>
          {/*<DashboardBannerForDesktop/>*/}
          <div
            className='bg-grey91 ml-3 mr-4 align-self-center'
            style={{ width: 1, height: 32 }}
          />
          {inMainScreen ? (
            <div
              className='d-flex align-items-center'
              style={{ marginBottom: '3px' }}
            >
              {isAbleToSeeDistributionDropdown && (
                <div style={{ marginRight: '24px' }}>
                  <DistributionsDropdown />
                </div>
              )}
              {!insights_active && isAbleToSeeFarmingUnitDropdown ? (
                <FarmingUnitsDropdown />
              ) : (
                <span />
              )}
            </div>
          ) : (
            <div></div>
          )}
        </div>
        {inMainScreen ? (
          <div className='d-none d-xl-block align-self-stretch'>
            <div
              className='pt-3 d-flex '
              style={{
                height: '100%',
                paddingBottom: '5px',
                paddingTop: '15px',
              }}
            >
              {visibleTabs.length > 1 &&
                visibleTabs.map((tab) => (
                  <div
                    key={tab.key}
                    className={`ml-3 d-flex justify-content-between flex-column pl-2${tab.key === 'monitoring' ? '' : ''}`}
                    ref={tab.key === 'farm_view' ? allFarmTabRef : null}
                  >
                    <div
                      id='link_div'
                      className='d-flex align-items-center justify-content-between'
                    >
                      <Link
                        to={tab.to}
                        onClick={() => {
                          handleTabClick(tab.key);
                          if (
                            tab.key === 'farm_view' &&
                            shouldShowAllFarmCoachmark
                          ) {
                            dismissAllFarmCoachmark();
                          }
                        }}
                        className={
                          'title text-size-14 font-weight-bold ' +
                          (tab.active ? 'title_active' : '')
                        }
                        style={{ textDecoration: 'none', letterSpacing: 1.5 }}
                      >
                        {tab.label}
                      </Link>
                    </div>
                    <div
                      className={
                        'text-left ' + (tab.active ? 'underline_div' : '')
                      }
                      style={{ width: tab.width, height: 4 }}
                    />
                  </div>
                ))}
              {visibleTabs.length === 1 && (
                <div
                  key={visibleTabs[0].key}
                  className='d-flex justify-content-between flex-column pl-2'
                  ref={
                    visibleTabs[0].key === 'farm_view' ? allFarmTabRef : null
                  }
                >
                  <div
                    id='link_div'
                    className='d-flex align-items-center justify-content-between'
                  >
                    <Link
                      to={visibleTabs[0].to}
                      onClick={() => {
                        handleTabClick(visibleTabs[0].key);
                        if (
                          visibleTabs[0].key === 'farm_view' &&
                          shouldShowAllFarmCoachmark
                        ) {
                          dismissAllFarmCoachmark();
                        }
                      }}
                      className={
                        'title text-size-14 font-weight-bold ' +
                        (visibleTabs[0].active ? 'title_active' : '')
                      }
                      style={{ textDecoration: 'none', letterSpacing: 1.5 }}
                    >
                      {visibleTabs[0].label}
                    </Link>
                  </div>
                  <div
                    className={
                      'text-left ' +
                      (visibleTabs[0].active ? 'underline_div' : '')
                    }
                    style={{ width: visibleTabs[0].width, height: 4 }}
                  />
                </div>
              )}
            </div>
          </div>
        ) : (
          <div></div>
        )}

        <div className='d-flex ' style={{ width: '30%', marginBottom: '5px' }}>
          {hasNotificationsCenterAccess && (
            <NotificationsCenterHeaderContainer
              openFromMainDashboard={inMainDashboard}
            />
          )}
          <div
            className='dropdown mr-3'
            style={{ marginLeft: hasNotificationsCenterAccess ? 0 : 'auto' }}
          >
            <div
              className='d-none d-sm-block notificationsBtn'
              data-toggle='dropdown'
              aria-haspopup='true'
              aria-expanded='false'
              role='button'
              aria-label={t('preferences')}
              style={preferencesButtonStyle}
            >
              <img
                src={require('images/icons/header/preferences_icon.svg')}
                alt=''
              />
            </div>
            <div className='dropdown-menu font-weight-normal text-size-16 mr-3'>
              <Link to='/' className='dropdown-item text-grey45'>
                {t('home')}
              </Link>
              <Link to='Account#' className='dropdown-item text-grey45'>
                {t('account')}
              </Link>
              {isAdmin ? (
                <Link
                  to='DistributionUnitsManagement#'
                  className='dropdown-item text-grey45'
                >
                  {t('admin')}
                </Link>
              ) : (
                ''
              )}
              {isAdmin ? (
                <Link
                  to='transmitter-test'
                  className='dropdown-item text-grey45'
                >
                  {t('transmitter_admin_page')}
                </Link>
              ) : (
                ''
              )}
              {isCropExpert && isAdmin ? (
                <Link
                  to='CropManagement#'
                  className='dropdown-item text-grey45'
                >
                  {t('crop_management')}
                </Link>
              ) : (
                ''
              )}
              {isAdmin ? (
                <Link
                  to='RemoteConfigurations#'
                  className='dropdown-item text-grey45'
                >
                  {'Remote Configurations'}
                </Link>
              ) : (
                ''
              )}
              <div className='dropdown-divider'></div>
              <a
                className='dropdown-item text-grey45'
                href='#'
                onClick={() => {
                  onLogoutButtonClick();
                }}
              >
                {t('logout')}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className='row bg-pale-grey-two'
        style={{ height: props.seperatorHeight.toString() + 'px' }}
      ></div>
      {props.displayMobileBanner && (
        <DashboardBannerForMobile closeBanner={props.closeBanner} />
      )}

      <AllFarmTabCoachmark
        anchorRef={allFarmTabRef}
        isOpen={shouldShowAllFarmCoachmark}
        message={t('new_section')}
        onDismiss={dismissAllFarmCoachmark}
      />
    </div>
  );
};

const mapStateToProps = function (state) {
  return {
    user_details: state.authentication_data.user_details,
    userData: state.authentication_data.user_data,
    selectedFarmingUnit: state.distribution_data.selected_entities.farming_unit,
    selectedDistribution:
      state.distribution_data.selected_entities.distribution,
    allDistributions: state.distribution_data.distributions,
    configuration_data: state.configuration_data,
  };
};

const mapDispatchToProps = {
  logout: authenticateActions.logout,
  setAllFarmTabCoachmarkSeen: userActions.set_new_section_seen,
};

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Header));
